import LocationOnIcon from "@mui/icons-material/LocationOn";
import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  Button,
  Container,
  InputAdornment,
  Menu,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import heroImg from "../assets/images/hero-bg-img.png";
import { useLocationContext } from "../context/LocationContext";

const cities = ["Delhi", "Mumbai", "Varanasi", "Lucknow", "Kanpur"];

const HomeHero = () => {
  const navigate = useNavigate();

  const [query, setQuery] = React.useState("");
  const { city, setCity } = useLocationContext();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const openCityMenu = (e) => setAnchorEl(e.currentTarget);
  const closeCityMenu = () => setAnchorEl(null);

  // const handleSearch = () => {
  //   navigate(`/city/${city.toLowerCase()}?q=${query}`);
  // };

  const handleSearch = () => {
    if (!city) return;

    navigate(
      `/search?city=${city.toLowerCase()}&q=${encodeURIComponent(query)}`,
    );
  };

  // React.useEffect(() => {
  //   detectCity();
  // }, []);

  // const detectCity = async () => {
  //   if (!navigator.geolocation) return;

  //   navigator.geolocation.getCurrentPosition(
  //     async (position) => {
  //       const { latitude, longitude } = position.coords;

  //       try {
  //         const res = await fetch(
  //           `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`,
  //         );
  //         const data = await res.json();

  //         const detectedCity =
  //           data.address.city || data.address.town || data.address.village;

  //         if (detectedCity) {
  //           setCity(detectedCity);
  //         }
  //       } catch (err) {
  //         console.error("Location detection failed", err);
  //       }
  //     },
  //     () => {
  //       // User denied permission – silently ignore
  //     },
  //   );
  // };

  return (
    <Box
      sx={{
        position: "relative",
        minHeight: { xs: "78vh", md: "88vh" },
        display: "flex",
        alignItems: "center",
        backgroundImage: `url(${heroImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Overlay */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          //   background:
          //     "linear-gradient(180deg, rgba(13,59,102,0.65), rgba(13,59,102,0.35))",

          background:
            "linear-gradient(180deg, rgba(13,59,102,0.72) 0%, rgba(13,59,102,0.45) 60%, rgba(13,59,102,0.65) 100%)",
        }}
      />

      <Container sx={{ position: "relative", zIndex: 1 }}>
        {/* CONTENT */}
        <Box
          sx={{
            textAlign: "center",
            maxWidth: { xs: "100%", md: 820 },
            mx: "auto",
            px: { xs: 1.5, md: 0 },
          }}
        >
          {/* Heading */}
          <Typography
            component="h1"
            sx={{
              color: "#FFFFFF",
              fontSize: { xs: "1.6rem", md: "3rem" },
              fontWeight: 800,
              lineHeight: 1.15,
            }}
          >
            Discover Places <span style={{ color: "#F4D35E" }}>Near You</span>
          </Typography>

          {/* Subtitle */}
          <Typography
            sx={{
              mt: 1.5,
              color: "rgba(255,255,255,0.9)",
              fontSize: { xs: "0.85rem", md: "1.05rem" },
              maxWidth: 620,
              mx: "auto",
            }}
          >
            Explore temples, hospitals, water parks, restaurants and more —
            trusted local places curated city by city.
          </Typography>

          {/* SEARCH BAR */}
          <Box
            sx={{
              mt: 4,
              mx: "auto",
              maxWidth: 860,
              backgroundColor: "#FFF7DE",
              borderRadius: { xs: 2, md: 999 },
              p: { xs: 2, md: 0.8 },
              boxShadow: "0 28px 60px rgba(0,0,0,0.45)",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                alignItems: "stretch",
                gap: { xs: 1.5, md: 0.5 },
                px: { md: 1 },
              }}
            >
              {/* LOCATION SELECTOR */}
              <Button
                onClick={openCityMenu}
                startIcon={<LocationOnIcon />}
                // endIcon={<KeyboardArrowDownIcon />}
                sx={{
                  justifyContent: "flex-start",
                  color: "#0D3B66",
                  fontWeight: 600,
                  textTransform: "none",
                  borderRadius: 2,
                  minHeight: 48,
                  px: 2,
                }}
              >
                {city || "Detecting location…"}
              </Button>

              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={closeCityMenu}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                PaperProps={{
                  sx: {
                    mt: 1, // ⬅ important gap so it doesn't touch the pill
                    borderRadius: 2,
                    minWidth: 160,
                    boxShadow: "0 12px 32px rgba(0,0,0,0.25)",
                  },
                }}
              >
                {cities.map((c) => (
                  <MenuItem
                    key={c}
                    onClick={() => {
                      setCity(c); // ✅ updates Header + HomeHero + everywhere
                      closeCityMenu();
                    }}
                  >
                    {c}
                  </MenuItem>
                ))}
              </Menu>

              {/* SEARCH INPUT */}
              <TextField
                fullWidth
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="Search places, categories or areas"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: "#6B8BAA" }} />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  "& fieldset": { border: "none" },
                  // backgroundColor: "#FAF0CA",
                  borderRadius: 2,
                  "& input": {
                    py: 1.4,
                    fontSize: "1rem",
                  },
                }}
              />

              {/* SEARCH BUTTON */}
              <Button
                onClick={handleSearch}
                sx={{
                  backgroundColor: "#F4D35E",
                  color: "#0D3B66",
                  fontWeight: 700,
                  minHeight: 48,
                  borderRadius: 2,
                  "&:hover": {
                    backgroundColor: "#E6BF3C",
                  },
                }}
              >
                Search
              </Button>
            </Box>
          </Box>

          {/* QUICK CATEGORIES */}
          <Box
            sx={{
              mt: { xs: 2, md: 3 },
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: 1,
              opacity: { xs: 0.9, md: 1 },
            }}
          >
            {[
              { label: "Mandir", icon: "🛕", url: "Mandir" },
              { label: "Hospital", icon: "🏥", url: "Hospital" },
              { label: "Water Park", icon: "🎢", url: "waterpark" },
              { label: "Restaurant", icon: "🍽", url: "restaurant" },
              { label: "Mall", icon: "🛍", url: "mall" },
            ].map((item) => (
              <Button
                key={item.label}
                onClick={() =>
                  navigate(
                    `/city/${city.toLowerCase()}/${item.url.toLowerCase()}`,
                  )
                }
                sx={{
                  backgroundColor: "rgba(255,255,255,0.12)",
                  color: "#FFFFFF",
                  backdropFilter: "blur(6px)",
                  borderRadius: 999,
                  px: 2,
                  py: 0.8,
                  fontSize: { xs: "0.70rem", md: "0.85rem" },
                  fontWeight: 500,
                  textTransform: "none",
                  border: "1px solid rgba(255,255,255,0.2)",
                  "&:hover": {
                    backgroundColor: "rgba(255,255,255,0.22)",
                  },
                }}
              >
                <span style={{ marginRight: 6 }}>{item.icon}</span>
                {item.label}
              </Button>
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default HomeHero;
